module.exports = __webpack_public_path__ + "img/zjgqjj_img.bb48d6b9.png";